import { isEqual } from 'lodash-es';
import { useRef } from 'react';

export const useDeepMemo = <T>(value: T): T => {
  const ref = useRef<T>();

  if (!isEqual(ref.current, value)) {
    ref.current = value;
  }

  return ref.current as T;
};
